// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3DILa","file":"styles_file__3CZGK"};